import { KeyValue, formatDate } from '@angular/common';
import {
  Component,
  EventEmitter,
  Inject,
  //Injectable,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { UserSummary } from '~/models/administration/user';
import { CustomFieldSummary } from '~/models/modules/customField';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { SecurityService } from '~/services/security.service';
import { ThemeManagerService } from '~/services/theme-manager';
import { LayoutComponent } from '../../layout/layout.component';
import { Router } from '@angular/router';
import { BehaviorSubject, zip } from 'rxjs';
import { GridLayoutManagerService } from '../../grid/layout/grid-layout-manager';
import { DateFormatPipe } from '~/shared/pipes/dateFormat';
import { FormatService } from '~/services/administration.ts/format';
import { SharedService } from '~/services/sharedService';

@Component({
    selector: 'asap-custom-fields-form',
    templateUrl: './form.html',
    styleUrls: ['./form.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
//@Injectable({ providedIn: 'root' })
export class CustomFieldsFormComponent implements OnInit, OnChanges {
  feildbehavior: BehaviorSubject<any>;
  _currentUser: UserSummary;
  _customFieldsDataFiltered: any[] = [];
  _form: FormGroup;
  _theme: string;
  _invalidForm: boolean = false;
  _editedCustomFields: CustomFieldSummary[] = [];
  _customFieldAuth: GridFieldAuthorization[] = [];
  _showSeparator = false;
  @Input() customFields: CustomFieldSummary[] = [];
  visibleCustomFields: CustomFieldSummary[] = [];

  @Output() customFieldsValue: EventEmitter<any> = new EventEmitter();
  @Output() customFieldsEditValue: EventEmitter<number> = new EventEmitter();
  @Output() customFieldsDeleteValue: EventEmitter<number> = new EventEmitter();
  @Output() customFieldsStatus: EventEmitter<boolean> = new EventEmitter();
  @Output() customForm: EventEmitter<any> = new EventEmitter();
  @Input() pageState: number;

  @Input() formName: string;
  @Input() page: string;
  @Input() accounts: any[];
  @Input() invalidSubmit: boolean = false;

  @Input() _customFieldsValue: any[];

  @ViewChild('UrlField') urlField: any;
  actionstate: any;

  constructor(
    private _fb: FormBuilder,
    private _securityService: SecurityService,
    private _themeManager: ThemeManagerService,
    private _customFieldsService: CustomFieldsService,
    private _layoutComponent: LayoutComponent,
    private _gridFieldAuth: GridFieldsService,
    private router: Router,
    private _sharedService: SharedService,
    private _formatService: FormatService,
    private _gridLayoutManagerServiceClearFeiled: GridLayoutManagerService,
  ) {
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
    this._currentUser = this._securityService.currentUser;
    this.feildbehavior = _gridLayoutManagerServiceClearFeiled.subscribeToCustomFeildClear();



    this.feildbehavior.subscribe(value => {
      if (value != undefined && value != null) {
        this._form.reset();
        this.actionstate = value
      }
    });

  }

  ngOnInit() {

    this.getCustomAuth();
    this._form.valueChanges.subscribe((x) => {
      this.customFieldsValue.emit(this._form.getRawValue());
      this.customForm.emit(this._form);
    });
  }
  _openeditCustomFields(customFieldId: number) {
    this.customFieldsEditValue.emit(customFieldId);
  }
  reactivate: boolean;
  _deleteCustomFields(customFieldId: number, customField: any) {
    this.reactivate = true;
    const sub = this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        let model: any = {
          name: customField.name,
          customFieldTypeId: customField.customFieldType.id,
          customFieldEntityId: customField.customFieldEntity.id,
          tabId: customField.tabId,
          customFieldData: customField.customFieldsData,
          page: this.page,
          accountIds: this.accounts,
        };
        this._customFieldsService
          .deleteCustomField(customFieldId, model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              this.customFieldsDeleteValue.emit(customFieldId);
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  // this._closeForm();
                } else {
                  return;
                }
              }
            }
            //   this._closeForm();
          });
      }
      else {
        this.reactivate = false;
      }
      sub.unsubscribe();
    });
    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Deactivate ' + customField.name,
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.getCustomAuth();
    this._initForm();
    this.customFieldsStatus.emit(this._form.invalid);
    //======================= commated given an error on value chang so value not emit from directive =============
    if (this._customFieldsValue && this._customFieldsValue.length > 0) {
      this._customFieldsValue.forEach((element: any) => {
        this._form.controls[element['Key']]?.setValue(element['Value']);
      });
    }
    //====================================================================================================
    // if (this._customFieldsValue) {
    //   const entries = Object.entries(this._customFieldsValue);
    //   for (const [index, [key, value]] of entries.entries()) {
    //    //   this._form.controls[key]?.setValue(value);
    //   }
    // }
    //==========================================================================
    if (this.pageState == 1) {
      this._form?.disable();
    }
    if (this._form.invalid && this._form.dirty && !this._form.pristine) {
      this._invalidForm = this._form.invalid;
    }
  }
  //=========================== SET DATA COMING FROM CUSTOM FIELD TO CONTROLS =================
  _modelformat: any;
  _initForm() {

    this._modelformat = this._formatService.dateFormat;
    if (this.customFields) {
      this.customFields = this.customFields.sort(
        (a, b) => a.formOrder - b.formOrder
      );
    }
    let record: any = {};
    if (this.customFields == undefined) {
      this.customFields = [];
    }
    this.customFields.forEach((x) => {
      if (x.customFieldType.type == 'Date') {
        record[x.name] = null;
      }
      else {
        if (x.customFieldType.type == 'Dropdown') {
          this._customFieldsDataFiltered[x.id] = this.customFields.find(
            (y) => y.id == x.id
          ).customFieldOptions;
          record[x.name] = new FormControl();
        } else {
          record[x.name] = '';
        }
      }
      if (x.entityId != null || x.entityUserId != null) {
        var customFieldVal;


        if (x.customFieldsData.find((c) => c.entityId == x.entityId) != null || x.customFieldsData.find((c) => c.entityId.toString() == x.entityUserId) != null) {

          var dataVal;
          if (x.entityUserId && x.entityId != -1) {
            dataVal = x.customFieldsData.find((c) => c.entityId.toString() == x.entityUserId).value;
          }
          else {
            dataVal = x.customFieldsData.find(
              (c) => c.entityId == x.entityId
            ).value;
          }
          if (x.customFieldType.id == 2) {
            var val = null;
            if (!isNaN(Number(dataVal)) && dataVal != '') {
              val = parseFloat(dataVal);
            }
            customFieldVal = val;
          } else {
            customFieldVal = dataVal;
          }
        }
        else {
          if (this._form) {
            if (x.customFieldType.id == 2) {
              if (this._form.get(x.name) && this._form.get(x.name).value)
                customFieldVal = parseFloat(this._form.get(x.name).value);
            }
            else {
              if (this._form.get(x.name) && this._form.get(x.name).value)
                customFieldVal = this._form.get(x.name).value;
            }

            x.customFieldsData.push({
              id: -1, value: customFieldVal,
              entityId: x.entityUserId ? x.entityUserId
                : x.entityId != -1 ? x.entityId : -1,
              customFieldId: x.id
            })
          }


        }
        if (customFieldVal == 'null') {
          customFieldVal = '';
        }
        if (
          x.customFieldType.type == 'Date' && customFieldVal) {
          record[x.name] = new Date(customFieldVal)

        } else if (x.customFieldType.type != 'Date' && customFieldVal) {
          record[x.name] = customFieldVal;
        }
      }
    });

    if (Object.keys(record).length > 0) {
      this._form = this._fb.group({});
      Object.entries(record).forEach((ent: Array<any>) => {
        this._form.addControl(ent[0],
          new FormControl(ent[1],

            this.customFields.find((x: CustomFieldSummary) => x.name === ent[0]).isRequired ? Validators.required
              : null
          )
        );
      });
    } else {
      this._form = this._fb.group(record);
    }
    if (this.pageState == 1) {
      this._form?.disable();
    }
  }

  _onCustomFieldChange() {
    this.customFieldsValue.emit(this._form.getRawValue());
    this.customFieldsStatus.emit(this._form.invalid);
    if (this._form.invalid && this._form.dirty && !this._form.pristine) {
      this._invalidForm = this._form.invalid;
    }
  }

  _handleFilter(customFieldId: number, value: any) {
    this._customFieldsDataFiltered[customFieldId] = this.customFields
      .find((x) => x.id == customFieldId)
      .customFieldOptions.filter(
        (s) => s.value.toLowerCase().indexOf(value.toLowerCase()) !== -1
      );
  }

  dataMove(newLocData: any, oldLocData: any) {
    const sysF: any[] = this.customFields;
    const sysFClone: any[] = [];

    sysF.forEach((element: any) => {
      sysFClone.push(Object.assign({}, element));
    });

    this.customFields.find((x) => x.id === oldLocData.id).formOrder =
      sysFClone.find((x) => x.id === newLocData.id).formOrder;
    this.customFields.find((x) => x.id === newLocData.id).formOrder =
      sysFClone.find((x) => x.id === oldLocData.id).formOrder;

    this._editedCustomFields = this.customFields;
  }

  dragEnd() {
    this._customFieldsService
      .updateCustomFieldsReorder(this._editedCustomFields)

      .subscribe((x: any) => {
        //this.customFields = x;
        //this._editedSystemFields = x;
      });
  }

  getCustomAuth() {
    // if (this.page == 'LocationTypes') return;
    // this._gridFields.getFileAuthorization(this._auth, this._currentUser.appRole.id)
    this._gridFieldAuth
      .getCustomFieldAuth(this.page, this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization[]) => {
        this._customFieldAuth = x;
        this.setVisibleCustomFields();
      });
  }
  setVisibleCustomFields() {
    //Quraim Add
    if (this.customFields.length > 0) {

      this.customFields.forEach((x) => {
        if (this.getAuthByName(x.name).canView == false) {
          let removedField = this.customFields.find(f => f.id === x.id);
          let itemIndex = this.customFields.indexOf(removedField);
          if (itemIndex > -1) {
            this.customFields.splice(itemIndex, 1);
          }
        }
      });


    }
    this.visibleCustomFields = [...this.customFields];
    this._showSeparator = this.visibleCustomFields.some(
      (x) => this.getAuthByName(x.name)?.canView && this.getAuthByName(x.name)?.gridFieldDefinition
    );
  }
  getAuthByName(name: any): GridFieldAuthorization {
    if (this._customFieldAuth) {
      const result = this._customFieldAuth.find(
        ({ gridFieldDefinition }) => gridFieldDefinition?.field === name
      );
      if (result) {
        return result;
      }
    }
    return new GridFieldAuthorization();
  }
  GotoUrl() {
    var url = this.urlField.nativeElement.value;
    if (!url.match('@^[hf]tt?ps?://@', url)) {
      url = 'http://' + url;
    }
    window.open(url, '_blank');
  }
}
